"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ProductQty;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _StockStatus = _interopRequireDefault(require("./StockStatus"));

var _NumberSelect = _interopRequireDefault(require("@developers/ui/NumberSelect"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _Refresh = _interopRequireDefault(require("@mui/icons-material/Refresh"));

function ProductQty(props) {
  var _React$useState = _react["default"].useState(props.qty),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      qty = _React$useState2[0],
      setQty = _React$useState2[1];

  _react["default"].useEffect(function () {
    if (props.qty != qty) {
      setQty(props.qty);
    }
  }, [props.qty]);

  function handleChange(value, type) {
    if (type == 'select') {
      props.updateCart(value);
    } else {
      setQty(value);
    }
  }

  function refreshCart() {
    props.updateCart(qty);
  }

  if (props.editable === false) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        paddingTop: 10
      }
    }, qty, /*#__PURE__*/_react["default"].createElement(_StockStatus["default"], {
      show: props.showStockStatus,
      qoh: props.qoh,
      qtyOnThisOrder: qty
    }));
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_NumberSelect["default"], {
    value: qty,
    onChange: handleChange,
    className: "form-control",
    disabled: props.loading,
    style: {
      width: '65px',
      margin: '0',
      display: 'inline-block',
      verticalAlign: 'super'
    }
  }), props.qty != qty && !props.loading ? /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: refreshCart,
    alt: "Recalculate",
    title: "Recalculate",
    size: "large"
  }, /*#__PURE__*/_react["default"].createElement(_Refresh["default"], null)) : null);
}